import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getPaperInfo: ['paperId', 'scope'],
  getPaperInfoSuccess: null,
  select: ['selected'],
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  exerciseId: '',
  selected: null,
  name: '',
  config: {},
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_PAPER_INFO_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    name: action.name,
  }),
  [Types.SELECT]: (state = INITIAL_STATE, action) => ({
    ...state,
    selected: action.selected,
  }),
});
